// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zghE4uyjXfh92CqFPwPc {
  height: 100%;
  overflow: auto;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Settings/Profile/index.module.less"],"names":[],"mappings":"AACA;EACE,YAAA;EACA,cAAA;AAAF","sourcesContent":["\n.container {\n  height: 100%;\n  overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `zghE4uyjXfh92CqFPwPc`
};
export default ___CSS_LOADER_EXPORT___;
